import { EmptyContainer } from "pages/home/components/CommunicationSection/RecentCommunicationsSection/components/EmptyContainer";
import { InquiriesInfo } from "pages/home/components/CommunicationSection/RecentCommunicationsSection/components/InquiriesInfo";
import { InquiriesTitle } from "pages/home/components/CommunicationSection/RecentCommunicationsSection/components/InquiriesTitle";
import { Container } from "pages/home/components/Layout";

/**
 * '최근 올라온 건의/문의' 데이터 컴포넌트
 */
export const RecentCommunications = ({ slicedData }) => {
  return (
    <>
      {slicedData.length === 0 ? (
        <EmptyContainer />
      ) : (
        <Container
          $height={315}
          $top={14}
          $bottom={35}
          style={{ border: "1px solid #E8E8E8" }}
        >
          {/* 카테고리 + 제목 */}
          <InquiriesTitle slicedData={slicedData} />
          {/* 답변 상태 + 날짜 */}
          <InquiriesInfo slicedData={slicedData} />
        </Container>
      )}
    </>
  );
};
